// // // onload of document trigger function
// //     	$(document).ready( function() {
// //         $('#bar-zipcode').hide();
// //         // replace input value with the variable zipcode. zipcode is a global variable from the geotargeting api
// //         $("#enterzipcode").val(zipcode);
// //         // Trigger the click of the submit button when the page is loaded to receive the fast shipping information
// //         $(".zip_button").trigger("click");
// //       });

// // onload of document trigger function
// $(document).ready(function () {
//   if (zipcode == "") {
//     console.log("zipcode not present");
//   } else {
//     // $("input[name='zip_code']").val(zipcode),
//     $("#enterzipcode").val(zipcode);
//     // $(".zip_button").trigger("click");
//     $(".zip_button").trigger("click");
//   }
// });

// // onload of document trigger function
//     $(document).ready( function() {
//       console.log('working geolocation');
//     let shipHeadline = document.getElementById("shipping-headline-results").innerHTML;
//         let zipCodeText = shipHeadline.replace(/ZIP Code:/g, "For Your Location");
//         document.getElementById("shipping-headline-results").innerHTML = zipCodeText;
//         var fastBanner = document.getElementById("shipping-headline-results").getElementsByClassName("zipcode"), i;
//             for (i = 0; i < fastBanner.length; i += 1) {
//             fastBanner[i].style.display = 'none';
//             }
//      /*if (zipcode == '') {
//         console.log('no zipcode');
//               } else {
//           console.log('fast geo zip ' + zipcode);
//           $("#enterzipcode").val(zipcode);
//           $(".zip_button").trigger("click");
//       }*/
//   });

// onload of document trigger function
$(document).ready(function () {
  $("#bar-zipcode").hide();
  if (zipcode == "") {
    console.log("no zipcode");
  } else {
    console.log("fast geo zip " + zipcode);
    $("#enterzipcode").val(zipcode);
    $(".zip_button").trigger("click");
  }
});
